import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import { Form, Offcanvas } from "react-bootstrap";
import '../../assets/css/Leads.css'
import { Link } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const Queue = () => {
  const [leads, setLeads] = useState([]);
  const [search, setSearch] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(50); const [page, setPage] = useState(1);
  const [totalRows, setTotalRows] = useState(0);
  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const [selectedLead, setSelectedLead] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const imageUrl = "https://devapi.bykit.in/storage/users/";
  const [selectedId, setSelectedId] = useState(null);
  const [show, setShow] = useState(false);
  const [estimationprice, setestimationprice] = useState('');
  const [pickupdropprice, setpickupdropprice] = useState(0);

  const [showestimation, setShowstimation] = useState(false);

  const today = new Date();
  const [showInvoice, setShowInvoice] = useState(false);
  const [showpayment, setshowpayment] = useState(false);
  const [showpickuptime, setshowpickuptime] = useState(false);
  const [showdroptime, setshowdroptime] = useState(false);


  const [invoice_amount, setinvoice_amount] = useState(false);

  const [invoiceamount, setinvoiceamount] = useState('');
  const [pickuptime, setpickuptime] = useState('');
  const [droptime, setdroptime] = useState('');

  const [payment_details, setpayment_details] = useState('');
  const minTime = new Date(today.setHours(8, 0, 0, 0));  // 08:00 AM
  const maxTime = new Date(today.setHours(21, 0, 0, 0)); // 09:00 PM

  const [invoiceData, setInvoiceData] = useState({
    invoiceFile: null,
    invoiceAmount: "",
    invoiceAmountnew: "",
  });

  const [formData, setFormData] = useState({
    price: "",
    details: "",
    pickup_type: ""
  });

  const [completeDetails, setCompleteDetails] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };


  const offcanvasRef = useRef(null);



  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        showOffcanvas &&
        offcanvasRef.current &&
        !offcanvasRef.current.contains(event.target)
      ) {
        setShowOffcanvas(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showOffcanvas]);



  let formattedPickupTime = ''
  if (selectedLead && selectedLead.pickup_time) {
    const pickup = new Date(selectedLead.pickup_time);
    formattedPickupTime = `${String(pickup.getDate()).padStart(2, '0')}-${String(pickup.getMonth() + 1).padStart(2, '0')}-${pickup.getFullYear()} ${String(pickup.getHours()).padStart(2, '0')}:${String(pickup.getMinutes()).padStart(2, '0')}`;
  }

  let formattedreachedTime = ''
  if (selectedLead && selectedLead.reached_workshop_time) {
    const reached = new Date(selectedLead.reached_workshop_time);
    formattedreachedTime = `${String(reached.getDate()).padStart(2, '0')}-${String(reached.getMonth() + 1).padStart(2, '0')}-${reached.getFullYear()} ${String(reached.getHours()).padStart(2, '0')}:${String(reached.getMinutes()).padStart(2, '0')}`;
  }

  let formattestartTime = ''
  if (selectedLead && selectedLead.start_service_time) {
    const start = new Date(selectedLead.start_service_time);
    formattestartTime = `${String(start.getDate()).padStart(2, '0')}-${String(start.getMonth() + 1).padStart(2, '0')}-${start.getFullYear()} ${String(start.getHours()).padStart(2, '0')}:${String(start.getMinutes()).padStart(2, '0')}`;
  }

  let formattecompleteTime = ''
  if (selectedLead && selectedLead.service_complete_time) {
    const complete = new Date(selectedLead.service_complete_time);
    formattecompleteTime = `${String(complete.getDate()).padStart(2, '0')}-${String(complete.getMonth() + 1).padStart(2, '0')}-${complete.getFullYear()} ${String(complete.getHours()).padStart(2, '0')}:${String(complete.getMinutes()).padStart(2, '0')}`;
  }

  let formatteDropTime = ''
  if (selectedLead && selectedLead.drop_time) {
    const drop = new Date(selectedLead.drop_time);
    formatteDropTime = `${String(drop.getDate()).padStart(2, '0')}-${String(drop.getMonth() + 1).padStart(2, '0')}-${drop.getFullYear()} ${String(drop.getHours()).padStart(2, '0')}:${String(drop.getMinutes()).padStart(2, '0')}`;
  }


  let insuranceexpiry = ''
  if (selectedLead && selectedLead.insurance_expiry_date) {
    const drop = new Date(selectedLead.insurance_expiry_date);
    insuranceexpiry = `${String(drop.getDate()).padStart(2, '0')}-${String(drop.getMonth() + 1).padStart(2, '0')}-${drop.getFullYear()}`;
  }

  const handleDetailsChange = (e) => {
    setCompleteDetails(e.target.value);
  };
  const labels = [
    "Meter",
    "Front Angle",
    "Right angle",
    "Left angle",
    "Back side",
    "Any dent/scratches"
  ];

  useEffect(() => {
    // Call the function once when the component mounts
    getLeadsData();
    // Set up interval to call it every 10 minutes (600,000 milliseconds)
    const intervalId = setInterval(() => {
      getLeadsData();
    }, 120000); // 10 minutes in milliseconds
    return () => clearInterval(intervalId);
  }, []);



  const handleAssignestimation = async (e) => {
    e.preventDefault();
    const storedLoginData = JSON.parse(localStorage.getItem("LoginData"));
    const token = storedLoginData?.token;

    const payload = {
      booking_id: selectedId,
      price: formData.price,
      details: formData.details,
      pickup_type: formData.pickup_type
    }
    console.log('assign astiment', payload)

    try {
      const response = await axios.post("https://devapi.bykit.in/api/admin/addestimationquote??type=live", payload,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

      console.log('addestiment', response)

      if (response.data.status === "RC200") {
        toast.success("Estimation added successfully!", { position: "top-right" });
        setShowstimation(false);

        setFormData({
          price: "",
          details: "",
          pickup_type: ""
        });
        getLeadsData();
        //window.location.reload();
      } else {
        toast.error("Failed to add estimation. Try again.", { position: "top-right" });
      }
    } catch (error) {
      console.error("Error adding estimation:", error);
      setShow(false);
    }
  };


  const acceptpayment = async (e) => {

    e.preventDefault();
    const storedLoginData = JSON.parse(localStorage.getItem("LoginData"));
    const token = storedLoginData?.token;

    const payload = {
      id: selectedId,
      invoice_amount: invoice_amount,
      payment_details: payment_details
    }
    console.log('assign astiment', payload)

    try {
      const response = await axios.post("https://devapi.bykit.in/api/admin/acceptpayment??type=live", payload,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

      console.log('addestiment', response)

      if (response.data.status === "RC200") {
        toast.success("Payment successfully accepted!", { position: "top-right" });
        setshowpayment(false);


        getLeadsData();
        //window.location.reload();
      } else {
        toast.error("Failed to add estimation. Try again.", { position: "top-right" });
      }
    } catch (error) {
      console.error("Error adding estimation:", error);
      setshowpayment(false);
    }
  };



  function toDate(value) {
    if (value instanceof Date) return value;
    if (typeof value === 'string' && value) {
      const d = new Date(value);
      if (!isNaN(d)) return d;
    }
    return null;
  }




  const add_expected_pickuptime = async (e) => {

    e.preventDefault();
    const storedLoginData = JSON.parse(localStorage.getItem("LoginData"));
    const token = storedLoginData?.token;

    const payload = {
      id: selectedId,
      expected_pickuptime: pickuptime
    }
    console.log('assign astiment', payload)

    try {
      const response = await axios.post("https://devapi.bykit.in/api/admin/add_expected_pickuptime??type=live", payload,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

      console.log('addestiment', response)

      if (response.data.status === "RC200") {
        toast.success("Successfully updated!", { position: "top-right" });
        setshowpickuptime(false)
        getLeadsData();

        //window.location.reload();
      } else {
        toast.error("Failed to add. Try again.", { position: "top-right" });
      }
    } catch (error) {
      console.error("Error adding:", error);
      pickuptimeModelOpen(false);
    }
  };


  function formatDateLocal(date) {
    const pad = (n) => n.toString().padStart(2, '0');
    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1);
    const day = pad(date.getDate());
    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());
    const seconds = pad(date.getSeconds());
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }



  const add_expected_droptime = async (e) => {

    e.preventDefault();
    const storedLoginData = JSON.parse(localStorage.getItem("LoginData"));
    const token = storedLoginData?.token;


    let ddate = formatDateLocal(droptime);

    const payload = {
      id: selectedId,
      expected_droptime: ddate
    }
    console.log('assign astiment', payload)

    try {
      const response = await axios.post("https://devapi.bykit.in/api/admin/add_expected_droptime??type=live", payload,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

      console.log('addestiment', response)

      if (response.data.status === "RC200") {
        toast.success("Successfully updated!", { position: "top-right" });
        setshowdroptime(false)


        getLeadsData();
        //window.location.reload();
      } else {
        toast.error("Failed to add. Try again.", { position: "top-right" });
      }
    } catch (error) {
      console.error("Error adding", error);
      setshowdroptime(false)
    }
  };







  const handleAssign = async (e) => {
    e.preventDefault();
    const storedLoginData = JSON.parse(localStorage.getItem("LoginData"));
    const token = storedLoginData?.token;

    const payload = {
      booking_id: selectedId,
      price: formData.price,
      details: formData.details,
      pickup_type: formData.pickup_type
    }
    console.log('assign astiment', payload)

    try {
      const response = await axios.post("https://devapi.bykit.in/api/admin/addestimation??type=live", payload,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

      console.log('addestiment', response)

      if (response.data.status === "RC200") {
        toast.success("Estimation added successfully!", { position: "top-right" });
        setShow(false);

        setFormData({
          price: "",
          details: "",
          pickup_type: ""
        });
        getLeadsData();
        //window.location.reload();
      } else {
        toast.error("Failed to add estimation. Try again.", { position: "top-right" });
      }
    } catch (error) {
      console.error("Error adding estimation:", error);
      setShow(false);
    }
  };

  const invoiceModelOpen = (lead, details, price, pickupdrop_price) => {
    if (pickupdrop_price) {
      setpickupdropprice(pickupdrop_price);
    }

    setestimationprice(price);
    setSelectedId(lead);
    setShowInvoice(true)
    setCompleteDetails(details);
  }

  const paymentModelOpen = (lead, invoice_amount) => {
    setSelectedId(lead);
    setshowpayment(true);
    setinvoice_amount(invoice_amount);
  }

  const pickuptimeModelOpen = (lead, expected_pickuptime) => {
    setSelectedId(lead);
    setshowpickuptime(true);
    setpickuptime(expected_pickuptime)
  }

  const droptimeModelOpen = (lead, expected_droptime) => {
    setSelectedId(lead);
    setshowdroptime(true);
    setdroptime(expected_droptime)
  }

  const assignModelOpen = (lead) => {
    setSelectedId(lead);
    setShow(true)
  }

  const assignModelOpenEstimation = (lead) => {
    setSelectedId(lead);
    setShowstimation(true)
  }







  // Function to open Offcanvas and set row data
  const handleShowDetails = (lead) => {
    setSelectedLead(lead);
    setShowOffcanvas(true);
  };

  useEffect(() => {
    getLeadsData();
  }, [rowsPerPage, page]);


  // Handle Input Changes
  const handleInputChange = (e) => {
    const { name, value, files } = e.target;
    setInvoiceData((prev) => ({
      ...prev,
      [name]: files ? files[0] : value,
    }));
  };

  const handleInputChangenew = (e) => {
    const { name, value, files } = e.target;
    setInvoiceData((prev) => ({
      ...prev,
      [name]: files ? files[0] : value,
    }));

    setInvoiceData(prevData => ({
      ...prevData,
      invoiceAmount: Number(pickupdropprice) + Number(value)
    }));
  };
  // Handle Form Submission
  const handleInvoiceSubmit = async (e) => {
    e.preventDefault();
    const storedLoginData = JSON.parse(localStorage.getItem("LoginData"));
    const token = storedLoginData?.token;

    if (!invoiceData.invoiceFile || !invoiceData.invoiceAmount) {
      alert("Please fill all fields and upload a valid PDF invoice.");
      return;
    }

    const formDataToSend = new FormData();
    formDataToSend.append("id", selectedId);
    formDataToSend.append("invoice", invoiceData.invoiceFile);
    formDataToSend.append("completed_details", completeDetails);
    formDataToSend.append("invoice_amount", invoiceData.invoiceAmount);

    console.log('formDataToSend', formDataToSend)

    try {
      const response = await axios.post(
        "https://devapi.bykit.in/api/admin/addinvoice??type=live",
        formDataToSend,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log('invoice upload', response)

      if (response.data.status === "RC200") {
        toast.success("Invoice uploaded successfully!");
        setShowInvoice(false);
        getLeadsData();
        //getLeadsData();
      } else {
        toast.error("Failed to upload invoice. Please try again.");
      }
    } catch (error) {
      console.error("Error uploading invoice:", error);
    }
  };

  const getLeadsData = async () => {
    const storedLoginData = JSON.parse(localStorage.getItem("LoginData"));
    const token = storedLoginData?.token;

    try {
      const response = await axios.get(
        `https://devapi.bykit.in/api/admin/queue/list?start=${(page - 1) * rowsPerPage}&length=${rowsPerPage}&?type=live`,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log('Queue', response.data)

      if (response.data && response.data.data) {
        setLeads(response.data.data);
        setTotalRows(response.data.recordsTotal || 0);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleStatusChange = async (e, row) => {

    const status = e.target.value;
    const storedLoginData = JSON.parse(localStorage.getItem("LoginData"));
    const token = storedLoginData?.token;

    setLeads(prevRows =>
      prevRows.map((r) =>
        r.id === row.id ? { ...r, status: status } : r
      )
    );

    const payload = {
      booking_id: row.id,
      status: status,

    }
    console.log('changebookingstatus', payload)

    try {
      const response = await axios.post("https://devapi.bykit.in/api/admin/changebookingstatus??type=live", payload,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

      console.log('changebookingstatus', response)

      if (response.data.status === "RC200") {
        toast.success("Status successfully changed", { position: "top-right" });
        setShow(false);

        if (status == 7) {
          alert('Please Add Expected Date and Time of Delivery.');
        }

        setFormData({
          price: "",
          details: "",
          pickup_type: ""
        });
        getLeadsData();
        //window.location.reload();
      } else {
        toast.error("Failed to add estimation. Try again.", { position: "top-right" });
      }
    } catch (error) {
      console.error("Error adding estimation:", error);
      setShow(false);
    }
  };

  let formattedDate = '';
  if (selectedLead) {
    const dateObj = new Date(selectedLead.service_date);
    formattedDate = `${String(dateObj.getDate()).padStart(2, '0')}-${String(dateObj.getMonth() + 1).padStart(2, '0')}-${dateObj.getFullYear()}`;
  }




  const handlePageChange = (newPage) => setPage(newPage);
  const handleRowsPerPageChange = (newRows) => {
    setRowsPerPage(newRows);
    setPage(1);
  };


  const columns = [
    {
      name: "Created Date",
      cell: (row) => (
        <div className="text-center">
          <p>{row.date || "N/A"}</p>
          <button className="btn droppickup_btn mt-1">
            {
              row.status === 7
                ? "Service Started"
                : row.status === 6
                  ? "Approved"
                  : row.status === 2
                    ? "Assigned (Delivery)"
                    : row.status === 1 ? "Converted"
                      : row.status === 3 ? "Pickup From User Location"
                        : row.status === 4 ? "Drop To Workshop"
                          : row.status === 5 ? "Quote Send By Manager"
                            : row.status === 6 ? "Approved By Client"
                              : row.status === 7 ? "Service Start"
                                : row.status === 8 ? "Service Completed"
                                  : row.status === 9 ? "Payment Completed"
                                    : row.status === 10 ? "Pickup From Workshop"
                                      : row.status === 11 ? "Delivery Completed"
                                        : row.status === 12 ? "Quote Rejected By User"
                                          : row.status === 13 ? "Cancelled"
                                            : row.status === 14 ? "Estimation Added"
                                              : row.status === 0 ? "Pending"
                                                : row.status === 16 ? "Case Closed"
                                                  : row.status === 17 ? "Estimation Sent"
                                                    : row.serviceestimation_status === 2 && row.serviceestimation_status != null ? "Estimation Rejected"
                                                      : ''
            }
          </button>
        </div>
      ),
      sortable: true,
    },
    {
      name: "Service Date",
      selector: (row) => {
        if (!row.service_date) return "N/A";

        const date = new Date(row.service_date);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // months are 0-indexed
        const year = date.getFullYear();

        return `${day}-${month}-${year}`;
      },
      sortable: true,
      width: "170px"
    }
    ,

    {
      name: "Service Type",
      selector: (row) => (row.service_type === 0 ? "Free" : row.service_type === 1 ? "Paid" : "N/A"),
      sortable: true,
    },
    {
      name: "Customer Name",
      selector: (row) => {
        const formatDateTime = (datetimeStr) => {
          const date = new Date(datetimeStr);
          const day = String(date.getDate()).padStart(2, '0');
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const year = date.getFullYear();
          const hours = String(date.getHours()).padStart(2, '0');
          const minutes = String(date.getMinutes()).padStart(2, '0');
          return `${day}-${month}-${year} ${hours}:${minutes}`;
        };

        return (
          <>
            {row.customer_name || "N/A"}
            <br />
            {row.phone || ""}
            {row.pickup_time && (
              <div style={{ marginTop: '4px' }}>
                <p style={{ margin: 0 }}>Pickup Time:</p>
                <p style={{ margin: 0 }}>{formatDateTime(row.pickup_time)}</p>
              </div>
            )}
          </>
        );
      },
      sortable: true,
    },

    {
      name: "Vehicle Number",
      selector: (row) => row.vehicle_name || "N/A",
      sortable: true,
    },
    {
      name: "Brand",
      cell: (row) => (
        <div className="d-flex align-items-center">
          <img
            src={row.brand_logo || "https://via.placeholder.com/50"}
            alt="Brand Logo"
            style={{ width: 50, height: 50, objectFit: "contain", marginRight: 10 }}
            onError={(e) => (e.target.src = "https://via.placeholder.com/50")}
          />

        </div>
      ),
      sortable: false,
    },
    {
      name: "Model",
      selector: (row) => row.model_name || " ",
      sortable: true,
    },
    {
      name: "Pickup/Drop",
      cell: (row) => {
        let buttonText = "N/A"; // Default text
        if (row.pickup_drop_facility === 0) {
          buttonText = "Pickup";
        } else if (row.pickup_drop_facility === 3) {
          buttonText = "Self Pickup/Drop";
        } else if (row.pickup_drop_facility === 1) {
          buttonText = "Drop";
        } else if (row.pickup_drop_facility === 2) {
          buttonText = "Pickup & Drop";
        }
        return (
          <div>
            <button className="btn droppickup_btn">
              {buttonText}

            </button>
            {row.pickupdrop_price ? 'Charges: ' + row.pickupdrop_price : ''}<br />
            {row.price ? 'Service Estimate: ' + row.price : ''}<br />
            {row.expected_pickuptime ? 'Pickup time (by client): ' + row.expected_pickuptime : ''}



            {row.expected_droptime ? (
              <p>
                Expected Delivery Time: {(() => {
                  const d = new Date(row.expected_droptime);

                  // format date parts
                  const day = d.getDate().toString().padStart(2, '0');
                  const month = (d.getMonth() + 1).toString().padStart(2, '0');
                  const year = d.getFullYear();

                  // format time parts
                  const hours = d.getHours().toString().padStart(2, '0');
                  const minutes = d.getMinutes().toString().padStart(2, '0');

                  return `${day}-${month}-${year} ${hours}:${minutes}`;
                })()}
              </p>
            ) : null}
          </div>
        );
      },
      sortable: true,
    },
    {
      name: "Action",
      cell: (row) => {
        let statusOptions = [];

        let estimationStatus =
          row.status === 18 || row.status === 7 || row.status === 8 || row.status === 15 || row.status === 16
            ? { counter: 11, value: 18, label: "Estimation accepted by Client" }
            : { counter: 12, value: 19, label: "Estimation rejected by Client" };


        // Define statusOptions based on pickup_drop_facility
        if (row.pickup_drop_facility == 2) {
          statusOptions = [
            { counter: 0, value: 14, label: "Pickup & Drop charges sent by Manager" },
            { counter: 1, value: 6, label: "Approved By Client" },
            { counter: 2, value: 2, label: "Delivery Assigned" },
            { counter: 3, value: 3, label: "Pick up from Client" },
            { counter: 4, value: 4, label: "Received at workshop" },

            { counter: 5, value: 17, label: "Estimation Sent to Client" },
            estimationStatus,



            { counter: 5, value: 7, label: "Service Started" },
            { counter: 7, value: 8, label: "Service Completed" },
            { counter: 8, value: 15, label: "Invoice sent to client" }, // fixed duplicate
            { counter: 9, value: 9, label: "Payment Completed" },
            { counter: 10, value: 10, label: "Pickup from workshop" },
            { counter: 11, value: 11, label: "Dropoff to client" },
            { counter: 12, value: 16, label: "Case Closed" },
          ];
        } else if (row.pickup_drop_facility == 0) {
          statusOptions = [
            { counter: 0, value: 14, label: "Pickup & Drop charges sent by Manager" },
            { counter: 1, value: 6, label: "Approved By Client" },
            { counter: 2, value: 2, label: "Delivery Assigned" },
            { counter: 3, value: 3, label: "Pick up from Client" },
            { counter: 4, value: 4, label: "Received at workshop" },

            { counter: 5, value: 17, label: "Estimation Sent to Client" },

            estimationStatus,


            { counter: 6, value: 7, label: "Service Started" },
            { counter: 7, value: 8, label: "Service Completed" },
            { counter: 8, value: 15, label: "Invoice sent to client" },
            { counter: 9, value: 9, label: "Payment Completed" },
            { counter: 10, value: 16, label: "Case Closed" },
          ];
        } else if (row.pickup_drop_facility == 1) {
          statusOptions = [
            { counter: 0, value: 14, label: "Pickup & Drop charges sent by Manager" },
            { counter: 1, value: 6, label: "Approved By Client" },
            { counter: 2, value: 2, label: "Delivery Assigned" },
            { counter: 3, value: 17, label: "Estimation Sent to Client" },
            estimationStatus,
            { counter: 5, value: 7, label: "Service Started" },
            { counter: 6, value: 8, label: "Service Completed" },
            { counter: 7, value: 15, label: "Invoice sent to client" },
            { counter: 8, value: 9, label: "Payment Completed" },
            { counter: 9, value: 10, label: "Pickup from workshop" },
            { counter: 10, value: 11, label: "Dropoff to client" },
            { counter: 11, value: 16, label: "Case Closed" },
          ];
        } else {
          statusOptions = [
            { counter: 0, value: 14, label: "Pickup & Drop charges sent by Manager" },
            // { counter: 1, value: 6, label: "Approved By Client" },

            { counter: 2, value: 17, label: "Estimation Sent to Client" },

            estimationStatus,

            { counter: 5, value: 7, label: "Service Started" },
            { counter: 6, value: 8, label: "Service Completed" },
            { counter: 7, value: 15, label: "Invoice sent to client" },
            { counter: 8, value: 9, label: "Payment Completed" },
            { counter: 11, value: 16, label: "Case Closed" },
          ];
        }

        let dstatus = '';

        if (row.payment_status == 1) {
          dstatus = [14, 6, 2, 3, 4, 7, 8, 15, 9, 17, 19];
        } else {
          dstatus = [14, 6, 2];
        }
        // ✔ Checkmark logic
        const checkMarkConditions = {
          14: [14],
          6: [14],
          2: dstatus,
          3: [14, 6, 2, 3],
          4: [14, 6, 2, 3, 4],
          17: [14, 6, 2, 3, 4, 17],

          7: [14, 6, 2, 3, 4, 7, 17, 18],
          8: [14, 6, 2, 3, 4, 7, 8, 17, 18],

          15: [14, 6, 2, 3, 4, 7, 8, 15, 17, 18],
          9: [14, 6, 2, 3, 4, 7, 8, 15, 9, 17, 19],
          10: [14, 6, 2, 3, 4, 7, 8, 15, 9, 10, 17, 19],
          11: [14, 6, 2, 3, 4, 7, 8, 15, 9, 10, 11, 17, 19],
          16: [14, 6, 2, 3, 4, 7, 8, 15, 9, 10, 11, 16],

          18: [14, 6, 2, 3, 4, 17, 18],
          19: [14, 6, 2, 3, 4, 17, 19, 15, 16],

        };

        // Disabled values
        let disabledValues = [];
        if (row.status == 14) {
          disabledValues = [2, 3, 4, 6, 9, 10, 11, 14, 15, 17, 19, 7, 8, 16];
        } else if (row.status == 2 || row.status == 3 || row.status == 17 || row.status == 1) {
          disabledValues = [2, 3, 4, 6, 9, 10, 11, 14, 15, 17, 19, 7, 8, 16];
        } else {
          disabledValues = [2, 3, 4, 6, 9, 10, 11, 14, 15, 17, 19];
        }

        //const disabledValues = [2, 6, 11, 14];


        return (
          <div>
            {/* Details Button */}
            <div className="d-flex justify-content-end">
              <button className="detail_btn d-flex align-items-center" onClick={() => handleShowDetails(row)}>
                <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" className="me-1 iconify iconify--heroicons" width="1em" height="1em" viewBox="0 0 24 24">
                  <g fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5">
                    <path d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178c.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178"></path>
                    <path d="M15 12a3 3 0 1 1-6 0a3 3 0 0 1 6 0"></path>
                  </g>
                </svg>
                Details
              </button>
            </div>

            {/* Status Dropdown */}
            {(row.status !== 1 && row.status !== 4 && row.status !== 8 || row.pickup_drop_facility === 1 || row.pickup_drop_facility === 3) &&
              !(row.pickup_drop_facility === 3 && row.status === 1) && !(row.serviceestimation_status == 2) ? (
              <div className="mt-2">
                <select
                  className="form-select"
                  onChange={(e) => handleStatusChange(e, row)}
                  value={row.status === 14 && row.estimation_status === 1 ? 6 : row.status}
                >
                  <option value="">Select Status</option>
                  {statusOptions.map((option) => {
                    const { value, label } = option;

                    const showCheck =
                      checkMarkConditions[row.status]?.includes(Number(value)) ||
                      (row.status === 14 && row.estimation_status === 1 && Number(value) === 6);

                    const isDisabled =
                      disabledValues.includes(value) ||
                      checkMarkConditions[row.status]?.includes(value) ||
                      showCheck ||
                      (label === "Case Closed" && row.payment_status == 0) || (label === "Case Closed" && row.pickup_drop_facility == 1 && row.status !== 11)
                      || (label === "Case Closed" && row.pickup_drop_facility == 2 && row.status !== 11);
                    // ||
                    // (
                    //   (row.pickup_drop_facility === 1 || row.pickup_drop_facility === 2) &&
                    //   row.status !== 11
                    // );



                    return (
                      <option key={value} value={value} disabled={isDisabled}>
                        {showCheck ? '✔ ' : ''}
                        {label}
                      </option>
                    );
                  })}
                </select>
              </div>
            ) : null}

            {row.serviceestimation_status === 2 && row.serviceestimation_status != null ? (
              <div style={{ fontSize: '14px' }}>
                <div>Estimation Rejected</div>
                <div>Price: {row.price}</div>
                <div>Payment: {row.payment_status === 1 ? 'Paid' : 'Pending'}</div>
              </div>
            ) : null}



            {/* Action Buttons */}

            {row.status === 1 && row.pickup_drop_facility === 2 && (
              <button className="edit_btn me-2" onClick={() => assignModelOpen(row.id)}>
                Pickup & Drop charges
              </button>
            )}

            {row.status === 1 && row.pickup_drop_facility === 0 && (
              <button className="edit_btn me-2" onClick={() => assignModelOpen(row.id)}>
                Pickup charges
              </button>
            )}

            {row.status === 1 && row.pickup_drop_facility === 1 && (
              <button className="edit_btn me-2" onClick={() => assignModelOpen(row.id)}>
                Drop charges
              </button>
            )}


            {(row.status === 2 && row.pickup_drop_facility === 1  ||  row.status === 4 || (row.pickup_drop_facility === 3 && row.status === 1) || (row.pickup_drop_facility === 1 && row.status === 14 && row.estimation_status == 1)) && (
              <button className="edit_btn me-2" onClick={() => assignModelOpenEstimation(row.id)}>
                Add Estimation
              </button>
            )}


            {/* //row.status === 14 || row.status === 2 || row.status === 5 || row.status === 6 || row.status === 7 ||  */}
            {(row.status === 8) && (
              <button className="edit_btn me-2" onClick={() => invoiceModelOpen(row.id, row.servicedetails, row.price, row.pickupdrop_price)}>
                Add Invoice
              </button>
            )}

            {(row.invoice_amount != null && row.payment_status != 1) && (
              <button className="edit_btn me-2" onClick={() => paymentModelOpen(row.id, row.invoice_amount)}>
                Accept Offline Payment
              </button>
            )}

            {/*
            {(row.payment_status != 1) && (
              <button className="edit_btn me-2" onClick={() => pickuptimeModelOpen(row.id,row.expected_pickuptime)}>
                Expected Pickup Time
              </button>
            )}
            */}

            {(row.status == 7 || row.status == 8 || row.status == 9 || row.status == 10) && (
              <button className="edit_btn me-2" onClick={() => droptimeModelOpen(row.id, row.expected_droptime)}>
                Expected Delivery Time
              </button>
            )}<br />


          </div>
        );
      },
    }

  ];

  return (
    <div className="container data-table-container p-2">
      <div className="d-flex align-items-center gap-3">
        <svg className="custom-icon" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" width="20px" height="20px" viewBox="0 0 24 24">
          <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m3 12l2-2m0 0l7-7l7 7M5 10v10a1 1 0 0 0 1 1h3m10-11l2 2m-2-2v10a1 1 0 0 1-1 1h-3m-6 0a1 1 0 0 0 1-1v-4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v4a1 1 0 0 0 1 1m-6 0h6"></path>
        </svg>

        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" width="18px" height="18px" viewBox="0 0 24 24">
          <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m8.25 4.5l7.5 7.5l-7.5 7.5"></path>
        </svg>

        <p className="m-0">Queue</p>



      </div>

      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        progressStyle={{ background: "green" }}
      />


      <div className='managebrand_box mt-3 mb-2 pt-4 pb-1'>
        <div>
          <h4 className='dashboard_head ps-3 pb-4'>Queue</h4>

        </div>
        <hr></hr>
        <div className="d-flex justify-content-between mt-3 px-3">

          <div>
            <input
              type="text"
              placeholder="Search keyword"
              className="search-input"
              style={{ padding: '8px' }}
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
        </div>

        <DataTable
          columns={columns}
          data={leads.filter((item) => item.customer_name && item.customer_name.toLowerCase().includes(search.toLowerCase()))}
          pagination
          responsive
          //paginationServer
          //paginationTotalRows={totalRows}
          paginationPerPage={rowsPerPage}
          paginationRowsPerPageOptions={[50, 100, 200, 300, 400]}
          onChangePage={handlePageChange}
          onChangeRowsPerPage={handleRowsPerPageChange}
          customStyles={{
            headRow: { style: { backgroundColor: "#E2E8F0", color: "#475569", fontWeight: "bold" } },
            pagination: { style: { borderTop: "1px solid #ddd", padding: "10px", backgroundColor: "#f8f9fa" } },
            cells: {
              style: {
                padding: "5px", // Reduces space between columns
                margin: "0",
              },
            },
            headCells: {
              style: {
                padding: "10px", // Reduces space in header cells
                margin: "0",
              },
            },
          }}
        />
      </div>
      <div>
        <Offcanvas className="custom-offcanvas" show={showOffcanvas} onHide={() => setShowOffcanvas(false)} placement="end">
          <Offcanvas.Header closeButton>
            <Offcanvas.Title></Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            {selectedLead && (

              <div className="lead-details" ref={offcanvasRef}>

                <div className="row">
                  <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                    <h4 className="detail_title">Service Details</h4>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                    <h4 className="detail_title">Customer Details</h4>
                  </div>
                </div>
                <hr style={{ marginBottom: 10, marginTop: 10 }} />

                <div className="row">
                  {/* First column */}
                  <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                    <div className="row">
                      <div className="col-6">
                        <h4 className="detail_title">Date</h4>
                        <p className="detail_text">{selectedLead.date}</p>
                      </div>
                      <div className="col-6">
                        <h4 className="detail_title">Service Type</h4>
                        <p className="detail_text">
                          {selectedLead.service_type === 0
                            ? `Free / ${selectedLead.free_service_no} Free Service`
                            : 'Paid'}
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* Second column */}
                  <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                    <div className="row">
                      <div className="col-6">
                        <h4 className="detail_title">Name</h4>
                        <p className="detail_text">{selectedLead.customer_name}-{selectedLead.phone}</p>
                      </div>
                      <div className="col-6">
                        <h4 className="detail_title">Vehicle Number:</h4>
                        <p className="detail_text">{selectedLead.vehicle_name}</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  {/* First column */}
                  <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                    <div className="row">

                      <div className="col-4">
                        <h4 className="detail_title">Total Amount</h4>
                        <p className="detail_text">{selectedLead.invoice_amount || "-"}</p>
                      </div>
                      <div className="col-4">
                        <h4 className="detail_title">Payment Status</h4>
                        <p className="detail_text">
                          {selectedLead.payment_status === 1 ? "Paid" : "Unpaid"}
                        </p>
                      </div>

                      <div className="col-4">
                        {selectedLead.invoice ?
                          <div>
                            <h4 className="detail_title">Invoice</h4>
                            <p className="detail_text"> <Link
                              to={'https://devapi.bykit.in/storage/brands/' + `${selectedLead.invoice}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{ marginRight: 10 }}
                            >
                              View Invoice
                            </Link></p></div> : null
                        }
                      </div>

                    </div>
                  </div>

                  {/* Second column */}
                  <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                    <div className="row">
                      <div className="col-12">
                        <h4 className="detail_title">Address</h4>
                        <p className="detail_text">{selectedLead.address}</p>
                      </div>

                    </div>
                  </div>
                </div>



                <div className="row">
                  {/* First column */}
                  <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                    <div className="row">
                      <div className="col-6">
                        <h4 className="detail_title">Pickup/Drop</h4>
                        <div className="mt-2">
                          <span className="btn droppickup_btn btn-sm">
                            {selectedLead?.pickup_drop_facility === 0
                              ? "Pickup"
                              : selectedLead?.pickup_drop_facility === 3
                                ? "Self Pickup/Drop"
                                : selectedLead?.pickup_drop_facility === 1
                                  ? "Drop"
                                  : "Pickup & Drop"}
                          </span>
                        </div>
                      </div>
                      <div className="col-6">
                        <h4 className="detail_title">Pickup/drop Charges </h4>
                        <p className="detail_text">{selectedLead.pickupdrop_price ? selectedLead.pickupdrop_price : 'N/A'}</p>
                      </div>
                    </div>
                  </div>
                  {/* Second column */}
                  <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                    <div className="row">
                      <div className="col-6">

                      </div>
                      <div className="col-6">

                      </div>
                    </div>
                  </div>
                </div>


                <div className="row">
                  {/* First column */}
                  <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                    <div className="row">
                      <div className="col-6">
                        <h4 className="detail_title">Pickup Time</h4>
                        <p className="detail_text">{formattedPickupTime}</p>
                      </div>
                      <div className="col-6">
                        <h4 className="detail_title">Pickup Images</h4>
                        <div className="d-flex flex-wrap">
                          {selectedLead.pickup_photos && selectedLead.pickup_photos.split(",").map((photo, index) => (
                            <div style={{ fontSize: 12, width: '45%' }}>
                              {labels[index] || `Photo ${index + 1}`}
                              <Link
                                key={index}
                                to={`${imageUrl}${photo}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ marginRight: 10 }}
                              >
                                <img
                                  src={`${imageUrl}${photo}`}
                                  alt=""
                                  className="pick_photo"
                                  onError={(e) => (e.target.style.display = "none")}
                                />
                              </Link>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Second column */}
                  <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                    <div className="row">
                      <h4 className="detail_title">Vehicle Details</h4>
                      <hr style={{ marginBottom: 10, marginTop: 10 }} />
                      <div className="col-4">
                        <h4 className="detail_title">Vehicle Number</h4>
                        <p className="detail_text">{selectedLead.vehicle_name}</p>
                      </div>
                      <div className="col-4">
                        <h4 className="detail_title">Brand</h4>
                        <p className="detail_text">  {selectedLead?.brand_logo && (
                          <img
                            src={selectedLead.brand_logo}
                            alt="Brand Logo"
                            style={{ width: 50, height: 50, objectFit: "contain", marginRight: 10 }}
                            onError={(e) => (e.target.style.display = "none")}
                          />
                        )}
                        </p>
                      </div>

                      <div className="col-4">
                        <h4 className="detail_title">Model</h4>
                        <p className="detail_text">{selectedLead.model_name}</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  {/* First column */}
                  <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                    <div className="row">
                      <div className="col-6">
                        <h4 className="detail_title">Workshop Reaching Time</h4>
                        <p className="detail_text">{formattedreachedTime}</p>
                      </div>
                      <div className="col-6">
                        <h4 className="detail_title">Drop to workshop</h4>
                        <div className="d-flex flex-wrap">
                          {selectedLead.receive_photo && selectedLead.receive_photo.split(",").map((photo, index) => (
                            <div style={{ fontSize: 12, width: '45%' }}>
                              {labels[index] || `Photo ${index + 1}`}
                              <Link
                                key={index}
                                to={`${imageUrl}${photo}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ marginRight: 10 }}
                              >
                                <img
                                  src={`${imageUrl}${photo}`}
                                  alt=""
                                  className="pick_photo"
                                  onError={(e) => (e.target.style.display = "none")}
                                />
                              </Link>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Second column */}
                  <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                    <div className="row">
                      <div className="col-6">
                        <h4 className="detail_title">Insurance Number</h4>
                        <p className="detail_text"> {selectedLead.insurance_number || "-"}</p>
                      </div>
                      <div className="col-6">
                        <h4 className="detail_title">Insurance Company</h4>
                        <p className="detail_text"> {selectedLead.insurance_company || "-"}</p>
                      </div>
                    </div>
                  </div>
                </div>


                <div className="row">
                  {/* First column */}
                  <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                    <div className="row">
                      <div className="col-6">
                        <h4 className="detail_title">Service Started Time</h4>
                        <p className="detail_text">{formattestartTime}</p>
                      </div>
                      <div className="col-6">
                        <h4 className="detail_title">Service Complete Time</h4>
                        <p className="detail_text">{formattecompleteTime}</p>
                      </div>
                    </div>
                  </div>
                  {/* Second column */}
                  <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                    <div className="row">
                      {selectedLead.insurance_copy_image ?
                        <div className="col-6">
                          <h4 className="detail_title">Insurance</h4>
                          <Link to={imageUrl + selectedLead.insurance_copy_image} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'underline' }}>View Attachment</Link>
                        </div> : null}

                      <div className="col-6">
                        <h4 className="detail_title">Insurance Expiry Date</h4>
                        <p className="detail_text">{insuranceexpiry != '01-01-1970' ? insuranceexpiry : "-"}</p>
                      </div>
                    </div>
                  </div>
                </div>








                <div className="row">
                  {/* First column */}
                  <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                    <div className="row">
                      <div className="col-6">
                        <h4 className="detail_title">Pickup from workshop</h4>
                        <p className="detail_text"> {selectedLead.work_complete_photo && selectedLead.work_complete_photo.split(",").map((photo, index) => (
                          <div style={{ fontSize: 12, width: '45%' }}>
                            {labels[index] || `Photo ${index + 1}`}
                            <Link
                              key={index}
                              to={`${imageUrl}${photo}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{ marginRight: 10 }}
                            >
                              <img
                                src={`${imageUrl}${photo}`}
                                alt=""
                                className="pick_photo"
                                onError={(e) => (e.target.style.display = "none")}
                              />
                            </Link>
                          </div>
                        ))}</p>
                      </div>
                      <div className="col-6">
                        <h4 className="detail_title">Drop to customer</h4>
                        <p className="detail_text">{selectedLead.delivery_complete_photo && selectedLead.delivery_complete_photo.split(",").map((photo, index) => (
                          <div style={{ fontSize: 12, width: '45%' }}>
                            {labels[index] || `Photo ${index + 1}`}
                            <Link
                              key={index}
                              to={`${imageUrl}${photo}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{ marginRight: 10 }}
                            >
                              <img
                                src={`${imageUrl}${photo}`}
                                alt=""
                                className="pick_photo"
                                onError={(e) => (e.target.style.display = "none")}
                              />
                            </Link>
                          </div>
                        ))}</p>
                      </div>
                    </div>
                  </div>
                  {/* Second column */}
                  <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                    <div className="row">
                      {selectedLead.rc_book_image && selectedLead.rc_book_image != 'https://devapi.bykit.in/blank-image.png' ?
                        <div className="col-12">
                          <h4 className="detail_title">RC Book:</h4>
                          <Link to={imageUrl + selectedLead.rc_book_image} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'underline' }}>View Attachment</Link>
                        </div> : null}

                    </div>
                  </div>
                </div>




                <div className="row">
                  {/* First column */}
                  <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                    <div className="row">
                      <div className="col-12">
                        <h4 className="detail_title">Drop Time</h4>
                        <p className="detail_text">{formatteDropTime}</p>
                      </div>
                      <div className="col-12">
                        <h4 className="detail_title">Message From Customer</h4>
                        <p className="detail_text">{selectedLead.message}</p>
                      </div>
                    </div>
                  </div>
                  {/* Second column */}
                  <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                    <div className="row">
                      <h4 className="detail_title" style={{ marginTop: 30 }}>Ratings</h4>
                      <hr style={{ marginBottom: 10, marginTop: 10 }} />
                      <div className="col-6">
                        <h4 className="detail_title">Ratings for Delivery Boy </h4>{selectedLead.rate_delivaryboy && Array.from({ length: 5 }, (_, i) => (
                          <span key={i} className={i < selectedLead.rate_delivaryboy ? "star filled" : "star"}>
                            {i < selectedLead.rate_delivaryboy ? '★' : '☆'}
                          </span>
                        ))}
                        {selectedLead.rate_delivaryboy ? <p className="detail_text">{selectedLead.comment_delivaryboy}</p> :
                          <p className="detail_text">No Rating given by User till now.</p>
                        }
                      </div>
                      <div className="col-6">

                        <h4 className="detail_title">Ratings for Service</h4> {selectedLead.rate_workshop && Array.from({ length: 5 }, (_, i) => (
                          <span key={i} className={i < selectedLead.rate_workshop ? "star filled" : "star"}>
                            {i < selectedLead.rate_workshop ? '★' : '☆'}
                          </span>
                        ))}
                        {selectedLead.rate_workshop ? <p className="detail_text">{selectedLead.comment_workshop}</p> :
                          <p className="detail_text">No Rating given by User till now.</p>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </Offcanvas.Body>
        </Offcanvas>
      </div>

      {/* Modal */}
      {showModal && (
        <div className="modal-overlay delete-overlay">
          <div className="modal-content delete-content">
            <div className="modal-header bg-dark text-white mt-0">
              <button type="button" className="btn-close btn-close-white" onClick={() => setShowModal(false)}></button>
            </div>
            <div className='p-3'>
              <p className='delete_text'>Are you sure, do you want to mark as converted?</p>
            </div>
            <hr className='p-0 m-0'></hr>
            <div className="modal-buttons text-end p-3">
              <button onClick={() => setShowModal(false)} className='model_dlt_btn me-3'>No</button>
              <button onClick={() => {
                // Call your function here
                console.log("Marked as Converted");
                setShowModal(false);
              }} className='model_dlt_btn'>Yes</button>
            </div>
          </div>
        </div>
      )}

      {showestimation && (
        <div className="modal fade show d-block" tabIndex="-1">
          <div className="modal-dialog modal_width">
            <div className="modal-content">
              <div className="modal-header bg-dark">
                <h3 className="modal-title text-light">Add Estimation</h3>
                <button type="button" className="btn-close btn-close-white" onClick={() => setShowstimation(false)}></button>
              </div>
              <div className="modal-body">
                <form onSubmit={handleAssignestimation}>
                  <div className="mb-3">
                    <label className="form-label">Price</label>
                    <input
                      type="number"
                      name="price"
                      className="form-control"
                      value={formData.price}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Details</label>
                    <input
                      name="details"
                      className="form-control"
                      value={formData.details}
                      onChange={handleChange}
                      required ></input>
                  </div>

                  {/* <div className="mb-3">
                    <label className="form-label">Pickup Type</label>
                    <input
                      type="text"
                      name="pickup_type"
                      className="form-control"
                      value={formData.pickup_type}
                      onChange={handleChange}
                      required />
                  </div> */}

                  <div className="d-flex justify-content-end  me-4">
                    <button type="submit" className="btn submit_btn d-flex align-items-center gap-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        aria-hidden="true"
                        role="img"
                        className="iconify iconify--ic"
                        width="1em"
                        height="1em"
                        viewBox="0 0 24 24"
                      >
                        <path
                          fill="currentColor"
                          d="M17.59 3.59c-.38-.38-.89-.59-1.42-.59H5a2 2 0 0 0-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7.83c0-.53-.21-1.04-.59-1.41zM12 19c-1.66 0-3-1.34-3-3s1.34-3 3 3s3 1.34 3 3s-1.34 3-3 3m1-10H7c-1.1 0-2-.9-2-2s.9-2 2 2h6c1.1 0 2 .9 2 2s-.9 2-2 2"
                        ></path>
                      </svg>
                      <span>Submit</span>
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}



      {show && (
        <div className="modal fade show d-block" tabIndex="-1">
          <div className="modal-dialog modal_width">
            <div className="modal-content">
              <div className="modal-header bg-dark">
                <h3 className="modal-title text-light">Add Pickup & Drop charges</h3>
                <button type="button" className="btn-close btn-close-white" onClick={() => setShow(false)}></button>
              </div>
              <div className="modal-body">
                <form onSubmit={handleAssign}>
                  <div className="mb-3">
                    <label className="form-label">Price</label>
                    <input
                      type="text"
                      name="price"
                      className="form-control"
                      value={formData.price}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Details</label>
                    <input
                      name="details"
                      className="form-control"
                      value={formData.details}
                      onChange={handleChange}
                      required ></input>
                  </div>

                  {/* <div className="mb-3">
                    <label className="form-label">Pickup Type</label>
                    <input
                      type="text"
                      name="pickup_type"
                      className="form-control"
                      value={formData.pickup_type}
                      onChange={handleChange}
                      required />
                  </div> */}

                  <div className="d-flex justify-content-end  me-4">
                    <button type="submit" className="btn submit_btn d-flex align-items-center gap-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        aria-hidden="true"
                        role="img"
                        className="iconify iconify--ic"
                        width="1em"
                        height="1em"
                        viewBox="0 0 24 24"
                      >
                        <path
                          fill="currentColor"
                          d="M17.59 3.59c-.38-.38-.89-.59-1.42-.59H5a2 2 0 0 0-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7.83c0-.53-.21-1.04-.59-1.41zM12 19c-1.66 0-3-1.34-3-3s1.34-3 3 3s3 1.34 3 3s-1.34 3-3 3m1-10H7c-1.1 0-2-.9-2-2s.9-2 2 2h6c1.1 0 2 .9 2 2s-.9 2-2 2"
                        ></path>
                      </svg>
                      <span>Submit</span>
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}


      {/* ------------invoicemodel-------------------- */}


      {showInvoice && (
        <div className="modal fade show d-block" tabIndex="-1">
          <div className="modal-dialog modal_width">
            <div className="modal-content">
              <div className="modal-header bg-dark">
                <h3 className="modal-title text-light">Add Invoice Details</h3>
                <button
                  type="button"
                  className="btn-close btn-close-white"
                  onClick={() => setShowInvoice(false)}
                ></button>
              </div>
              <div className="modal-body">
                <form onSubmit={handleInvoiceSubmit}>
                  {/* Invoice Upload Field */}
                  <div className="mb-3">
                    <label className="form-label">Upload Invoice (PDF)</label>
                    <input
                      type="file"
                      name="invoiceFile"
                      className="form-control"
                      // accept="application/pdf"
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label"><span style={{ width: '270px', display: 'inline-block' }}>Estimation charges (already provided):</span> {estimationprice}</label><br />

                    <label className="form-label"><span style={{ width: '270px', display: 'inline-block' }}>Pickup & Drop charges:</span> {pickupdropprice}</label><br />

                    <label className="form-label"><span style={{ width: '270px', display: 'inline-block' }}>Details:</span> {completeDetails}</label><br />
                    <label className="form-label"><span style={{ width: '270px', display: 'inline-block' }}>Invoice Amount (Including GST):</span><input
                      type="number"
                      style={{ borderWidth: 1, borderColor: '#ced4da', padding: 5 }}
                      name="invoiceAmountnew"
                      value={invoiceData.invoiceAmountnew}
                      onChange={handleInputChangenew}
                      required
                    /></label>
                  </div>

                  {/* Invoice Amount */}
                  <div className="mb-3">
                    <label className="form-label">Total Payable amount</label>
                    <input
                      type="number"
                      name="invoiceAmount"
                      className="form-control"
                      readOnly
                      value={invoiceData.invoiceAmount}
                      onChange={handleInputChange}
                      required
                    />
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Details</label>
                    <textarea
                      name="completeDetails"
                      className="form-control"
                      value={completeDetails} // Show API data
                      onChange={handleDetailsChange}
                      rows="4"
                    ></textarea>
                  </div>


                  {/* Submit Button */}
                  <div className="d-flex justify-content-end me-4">
                    <button type="submit" className="btn submit_btn d-flex align-items-center gap-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        aria-hidden="true"
                        role="img"
                        className="iconify iconify--ic"
                        width="1em"
                        height="1em"
                        viewBox="0 0 24 24"
                      >
                        <path
                          fill="currentColor"
                          d="M17.59 3.59c-.38-.38-.89-.59-1.42-.59H5a2 2 0 0 0-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7.83c0-.53-.21-1.04-.59-1.41zM12 19c-1.66 0-3-1.34-3-3s1.34-3 3 3s3 1.34 3 3s-1.34 3-3 3m1-10H7c-1.1 0-2-.9-2-2s.9-2 2 2h6c1.1 0 2 .9 2 2s-.9 2-2 2"
                        ></path>
                      </svg>
                      <span>Submit</span>
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}

      {showpayment && (
        <div className="modal fade show d-block" tabIndex="-1">
          <div className="modal-dialog modal_width">
            <div className="modal-content">
              <div className="modal-header bg-dark">
                <h3 className="modal-title text-light">Accept Payment</h3>
                <button
                  type="button"
                  className="btn-close btn-close-white"
                  onClick={() => setshowpayment(false)}
                ></button>
              </div>
              <div className="modal-body">
                <form onSubmit={acceptpayment}>
                  <div className="mb-3">
                    <label className="form-label">Total Payable amount (Rs. {invoice_amount})</label>
                    {/* <input
                      type="number"
                      name="invoiceAmount"
                      className="form-control"
                      value={invoice_amount}
                      onChange={(e) => setinvoiceamount(e.target.value)}
                      required
                    /> */}
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Details</label>
                    <textarea
                      name="completeDetails"
                      className="form-control"
                      value={payment_details} // Show API data
                      onChange={(e) => setpayment_details(e.target.value)}
                      required
                      rows="4"
                    ></textarea>
                  </div>
                  <div className="d-flex justify-content-end me-4">
                    <button type="submit" className="btn submit_btn d-flex align-items-center gap-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        aria-hidden="true"
                        role="img"
                        className="iconify iconify--ic"
                        width="1em"
                        height="1em"
                        viewBox="0 0 24 24">
                        <path
                          fill="currentColor"
                          d="M17.59 3.59c-.38-.38-.89-.59-1.42-.59H5a2 2 0 0 0-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7.83c0-.53-.21-1.04-.59-1.41zM12 19c-1.66 0-3-1.34-3-3s1.34-3 3 3s3 1.34 3 3s-1.34 3-3 3m1-10H7c-1.1 0-2-.9-2-2s.9-2 2 2h6c1.1 0 2 .9 2 2s-.9 2-2 2"
                        ></path>
                      </svg>
                      <span>Submit</span>
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}


      {showpickuptime && (
        <div className="modal fade show d-block" tabIndex="-1">
          <div className="modal-dialog modal_width">
            <div className="modal-content">
              <div className="modal-header bg-dark">
                <h3 className="modal-title text-light">Add Expected Pickup Time</h3>
                <button
                  type="button"
                  className="btn-close btn-close-white"
                  onClick={() => setshowpickuptime(false)}
                ></button>
              </div>
              <div className="modal-body">
                <form onSubmit={add_expected_pickuptime}>
                  <div className="mb-3">
                    <input
                      type="datetime-local"
                      name="pickuptime"
                      className="form-control"
                      value={pickuptime}
                      onChange={(e) => setpickuptime(e.target.value)}
                      required
                    />
                  </div>
                  <div className="d-flex justify-content-end me-4">
                    <button type="submit" className="btn submit_btn d-flex align-items-center gap-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        aria-hidden="true"
                        role="img"
                        className="iconify iconify--ic"
                        width="1em"
                        height="1em"
                        viewBox="0 0 24 24">
                        <path
                          fill="currentColor"
                          d="M17.59 3.59c-.38-.38-.89-.59-1.42-.59H5a2 2 0 0 0-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7.83c0-.53-.21-1.04-.59-1.41zM12 19c-1.66 0-3-1.34-3-3s1.34-3 3 3s3 1.34 3 3s-1.34 3-3 3m1-10H7c-1.1 0-2-.9-2-2s.9-2 2 2h6c1.1 0 2 .9 2 2s-.9 2-2 2"
                        ></path>
                      </svg>
                      <span>Submit</span>
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}

      {showdroptime && (
        <div className="modal fade show d-block" tabIndex="-1">
          <div className="modal-dialog modal_width">
            <div className="modal-content">
              <div className="modal-header bg-dark">
                <h3 className="modal-title text-light">Add Expected Drop Time</h3>
                <button
                  type="button"
                  className="btn-close btn-close-white"
                  onClick={() => setshowdroptime(false)}
                ></button>
              </div>
              <div className="modal-body">
                <form onSubmit={add_expected_droptime}>




                  <DatePicker
                    selected={toDate(droptime)}
                    onChange={(date) => setdroptime(date)}
                    showTimeSelect
                    timeIntervals={30}                 // 30-minute intervals
                    dateFormat="dd-MM-yyyy HH:mm"     // Custom date/time format
                    timeCaption="Time"
                    className="form-control"
                    minTime={minTime}
                    maxTime={maxTime}
                  />



                  <div className="d-flex justify-content-end me-4">
                    <button type="submit" className="btn submit_btn d-flex align-items-center gap-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        aria-hidden="true"
                        role="img"
                        className="iconify iconify--ic"
                        width="1em"
                        height="1em"
                        viewBox="0 0 24 24">
                        <path
                          fill="currentColor"
                          d="M17.59 3.59c-.38-.38-.89-.59-1.42-.59H5a2 2 0 0 0-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7.83c0-.53-.21-1.04-.59-1.41zM12 19c-1.66 0-3-1.34-3-3s1.34-3 3 3s3 1.34 3 3s-1.34 3-3 3m1-10H7c-1.1 0-2-.9-2-2s.9-2 2 2h6c1.1 0 2 .9 2 2s-.9 2-2 2"
                        ></path>
                      </svg>
                      <span>Submit</span>
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}



    </div>
  );
};

export default Queue;
